export function getOrderPath(paymentId) {
  switch (parseInt(paymentId, 10)) {
    case 0:
      return require(`@/assets/imgs/withdraw/online-banking-withdraw.png`);
    case 1002:
      return require(`@/assets/imgs/withdraw/Virtual-currency-withdraw.png`);
    case 1003:
      return require(`@/assets/imgs/withdraw/exact-speed-withdraw.png`);
    default:
      return require(`@/assets/imgs/withdraw/default-withdraw.png`);
  }
}
